<template>
  <v-layout class="ids-bottom-btn" row wrap v-if="buttons != null">
    <v-flex xs12 text-xs-center>
      <v-btn v-for="(button, index) in buttons" :loading="button.loading" :disabled="button.disabled" :key="index"
        @click="button.func(button.params)" text-xs-center
        :class="[button.style, { second: !button.primary, bottom_btn: true, primary: button.primary }]">
        <v-icon v-if="button.icon != null" right>{{ button.icon }}</v-icon>
        <span>{{ button.title }}</span>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'iDS-BottomBtn',

  data: function () {
    return {}
  },

  computed: {
    buttons() {
      return this.getBottomBtn()
    },
  },

  methods: {
    ...mapGetters('app', ['getBottomBtn']),
  },

  mounted: function () { },
}
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.ids-bottom-btn button.bottom_btn {
  height: 100%;
  margin: 0px;
  font-size: 1.2rem;
}

.ids-bottom-btn button.bottom_btn.one {
  width: 100%;
}

.ids-bottom-btn button.bottom_btn.two {
  width: 50%;
}

.ids-bottom-btn button.bottom_btn.three {
  width: 33.33%;
}

.ids-bottom-btn button.bottom_btn.four {
  width: 25%;
  min-width: 25%;
}

.ids-bottom-btn button.bottom_btn.five {
  width: 20%;
  min-width: 20%;
}

.ids-bottom-btn button.bottom_btn div.v-btn__content.second {
  background: #eeeeee;
}

.ids-bottom-btn {
  height: 36px;
}
</style>